module.exports = __webpack_public_path__ + "static/media/pat.8798c68a.png";